module.exports = __webpack_public_path__ + "static/media/Circo2025_24.32b7f20b.webp";